<template>
    <div>
        <Header />
        <PageTitle />
        <CommercialDisinfectionServices />
        <Footer />
    </div>
</template>

<script>
import Header from '../Layout/Header'
import PageTitle from '../ServicesOne/PageTitle'
import CommercialDisinfectionServices from '../ServicesOne/CommercialDisinfectionServices'
import Footer from '../Layout/Footer'

export default {
    name: 'ServicesPageOne',
    components: {
        Header,
        PageTitle,
        CommercialDisinfectionServices,
        Footer,
    }
}
</script>